import { createFileRoute, notFound } from "@tanstack/react-router";
import { findKotaBySlug, getProvinsi } from "@/data/locations";
import { displayLocationTitle } from "@/lib/prayer/copy";
import { BukaPuasaPage } from "@/components/prayer/BukaPuasaPage";
import { SiteShell } from "@/components/layout/SiteShell";
import { EmptyLocationState } from "@/components/prayer/EmptyLocationState";

export const Route = createFileRoute("/jadwal-buka-puasa/$kota/")({
  loader: ({ params }) => {
    const loc = findKotaBySlug(params.kota) ?? getProvinsi(params.kota);
    if (!loc) throw notFound();
    return { loc };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { loc } = loaderData;
    const display = displayLocationTitle(loc);
    const title = `Jadwal Buka Puasa ${display} - Waktu Maghrib Hari Ini`;
    const desc = `Jadwal buka puasa ${display} hari ini sesuai metode Kemenag RI. Lengkap dengan waktu imsak, subuh, dan isya untuk sebulan penuh.`;
    const canonical = `https://hari.co.id/jadwal-buka-puasa/${loc.slug}/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: canonical },
        { property: "og:image", content: "https://hari.co.id/og-jadwal-imsak.svg" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "robots", content: "index, follow, max-image-preview:large" },
      ],
      links: [{ rel: "canonical", href: canonical }],
    };
  },
  component: () => {
    const { loc } = Route.useLoaderData();
    return <BukaPuasaPage location={loc} />;
  },
  notFoundComponent: () => (
    <SiteShell>
      <EmptyLocationState variant="buka-puasa" />
    </SiteShell>
  ),
});